import React, { useState, useEffect } from "react";
import MealsSummary from "./MealsSummary";
import AvailableMeals from "./AvailableMeals";
import LoginPage from "../UI/LoginPage";
import classes from './Meals.module.css';

const Meals = () => {
  const [user, setUser] = useState(null);
  const [login, setLogin] =useState(false)

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (loggedInUser) {
      setUser(loggedInUser);
    }
  }, []);

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser);
    localStorage.setItem("loggedInUser", JSON.stringify(loggedInUser));
    setLogin(true)
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("loggedInUser");
    setLogin(false);
  };

  return (
    <React.Fragment>
      <MealsSummary />
      {user ? (
        <h1 className={classes.user}>Welcome, {user.name}!</h1>
      ) : (
        <h1 className={classes.user}>Welcome, Guest! Please Login to See Menu and Placed Order.</h1>
      )}

      {!user ? (
        <LoginPage onLogin={handleLogin} />
      ) : (
        <React.Fragment>
          <button className={classes.logoutButton} onClick={handleLogout}>
            Logout
          </button>
        </React.Fragment>
      )}

{login || user ? <AvailableMeals /> : null}

      {/* <AvailableMeals /> */}
    </React.Fragment>
  );
};

export default Meals;
